// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { RotatingLines } from "react-loader-spinner";
// import { useSearchWorkers } from "../../../context/SearchWorkersContext";
// import { useJobCreate } from "../../../context/JobCreateContext";

// const WorkerCareActivitiesComponent = ({
//   onUpdate,
//   selectedActivitiesValue = [],
//   selectedSupportTypes = [],
//   isCareActivityDetailsError,
//   clearError,
// }) => {
//   const { fetchActivitiesBySupportTypeLabel } = useSearchWorkers();

//   const { jobSelections, getJobCreateIdFromCookies } = useJobCreate();

//   const supportTypeDetails =
//     Array.isArray(selectedSupportTypes) && selectedSupportTypes.length > 0
//       ? selectedSupportTypes
//       : Array.isArray(jobSelections?.supportTypeDetails)
//         ? jobSelections.supportTypeDetails
//         : [];

//   const [selectedActivities, setSelectedActivities] = useState(() => {
//     const initial = {};
//     const activities = selectedActivitiesValue.length
//       ? selectedActivitiesValue
//       : jobSelections?.careActivityDetails || [];
//     activities.forEach((activity) => (initial[activity] = true));
//     return initial;
//   });

//   const [computedErrors, setComputedErrors] = useState([]);
//   const [visibleErrors, setVisibleErrors] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activitiesData, setActivitiesData] = useState([]);

//   const cadcContainerRef = useRef(null);

//   const navigate = useNavigate();

//   useEffect(() => {
//     const jobCreateId = getJobCreateIdFromCookies();
//     if (!jobCreateId) {
//       navigate("/account/fs-dashboard/my-jobs/new/standard");
//     }
//   }, [getJobCreateIdFromCookies, navigate]);

//   useEffect(() => {
//     if (jobSelections?.careActivityDetails) {
//       const initialSelected = {};
//       jobSelections.careActivityDetails.forEach(
//         (activity) => (initialSelected[activity] = true)
//       );
//       setSelectedActivities(initialSelected);
//     }
//   }, [jobSelections]);

//   useEffect(() => {
//     if (isCareActivityDetailsError) {
//       const selectedKeys = Object.keys(selectedActivities).filter(k => selectedActivities[k]);
//       const fallback = selectedKeys.length === 0
//         ? [{ field: "careActivities", message: "Please select at least one care activity." }]
//         : [];
//       setVisibleErrors(computedErrors.length ? computedErrors : fallback);
//       smoothScrollToTop();
//     } else {
//       setVisibleErrors([]);
//     }
//   }, [isCareActivityDetailsError]);


//   useEffect(() => {
//     console.log(
//       "[WorkerCareActivitiesComponent] Using Support Type Details:",
//       supportTypeDetails
//     );

//     if (supportTypeDetails.length > 0) {
//       getActivityData()
//         .then(setActivitiesData)
//         .catch((error) => {
//           console.error("Failed to load activities:", error);
//           setActivitiesData([]);
//         });
//     } else {
//       setActivitiesData([]);
//     }
//   }, [supportTypeDetails]);

//   const getActivityData = async () => {
//     setLoading(true);
//     let activities = [];

//     if (Array.isArray(supportTypeDetails)) {
//       for (const supportTypeLabel of supportTypeDetails) {
//         try {
//           const fetchedActivities = await fetchActivitiesBySupportTypeLabel(
//             supportTypeLabel
//           );
//           activities = activities.concat(fetchedActivities);
//         } catch (error) {
//           console.error(
//             `Error fetching activities for support type label "${supportTypeLabel}":`,
//             error
//           );
//         }
//       }
//     } else {
//       console.error(
//         "supportTypeDetails is not a valid array:",
//         supportTypeDetails
//       );
//     }

//     setLoading(false);
//     return activities.map((activity) => ({
//       label: activity.name || activity.label,
//       description: activity.description,
//     }));
//   };

//   const toggleActivity = (label) => {
//     setSelectedActivities((prevState) => {
//       const newState = { ...prevState, [label]: !prevState[label] };
//       notifyUpdate(newState);
//       return newState;
//     });
//     clearError && clearError();
//   };

//   const notifyUpdate = (newSelectedActivities) => {
//     const selectedKeys = Object.keys(newSelectedActivities).filter(k => newSelectedActivities[k]);
//     const errors = selectedKeys.length === 0
//       ? [{ field: "careActivities", message: "Please select at least one care activity." }]
//       : [];

//     setComputedErrors(errors);
//     onUpdate({ data: selectedKeys, errors, isValid: errors.length === 0 });

//     if (isCareActivityDetailsError) setVisibleErrors(errors);
//     else setVisibleErrors([]);
//   };


//   const smoothScrollToTop = () => {
//     const container = cadcContainerRef.current;
//     if (!container) return;

//     const scrollDuration = 600;
//     const scrollStep = container.scrollTop / (scrollDuration / 15);

//     const scrollInterval = setInterval(() => {
//       if (container.scrollTop > 0) {
//         container.scrollTop -= scrollStep;
//       } else {
//         clearInterval(scrollInterval);
//       }
//     }, 15);
//   };

//   const highlightErrorFields = () => {
//     const selectedKeys = Object.keys(selectedActivities).filter(
//       (key) => selectedActivities[key]
//     );

//     const errors = [];

//     if (selectedKeys.length === 0) {
//       errors.push("Please select at least one care activity.");
//     }

//     console.log("[Debug] highlightErrorFields - Errors:", errors);

//     return {
//       errors,
//       isValid: errors.length === 0,
//     };
//   };

//   return (
//     <div className="care-activities-container">
//       <h2>Select required support activities.</h2>
//       {isCareActivityDetailsError && visibleErrors.length > 0 && (
//         <div className="wcac-error-message">
//           <ul>
//             {visibleErrors.map((err, index) => <li key={index}>{err.message}</li>)}
//           </ul>
//         </div>
//       )}

//       <div className="care-activities-scrollable" ref={cadcContainerRef}>
//         {loading ? (
//           <div style={{ textAlign: "left", marginLeft: "20px" }}>
//             <RotatingLines
//               visible={true}
//               height="76"
//               width="36"
//               color="grey"
//               strokeWidth="3"
//               animationDuration="0.75"
//               ariaLabel="rotating-lines-loading"
//               wrapperStyle={{}}
//               wrapperClass=""
//             />
//           </div>
//         ) : activitiesData.length > 0 ? (
//           activitiesData.map((activity, index) => (
//             <button
//               key={index}
//               className={`activities-horizontal-button ${selectedActivities[activity.label] ? "selected" : ""
//                 }`}
//               onClick={() => toggleActivity(activity.label)}
//             >
//               <div className="button-checkmark">
//                 {selectedActivities[activity.label] ? "✓" : ""}
//               </div>
//               <div className="button-text">{activity.label}</div>
//             </button>
//           ))
//         ) : (
//           <p>No activities available for the selected support types.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default WorkerCareActivitiesComponent;

import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { FaSearch } from "react-icons/fa";
import { useSearchWorkers } from "../../../context/SearchWorkersContext";
import { useJobCreate } from "../../../context/JobCreateContext";

const WorkerCareActivitiesComponent = ({
  onUpdate,
  selectedActivitiesValue = [],
  selectedSupportTypes = [],
  isCareActivityDetailsError,
  clearError,
}) => {
  const { fetchActivitiesBySupportTypeLabel } = useSearchWorkers();
  const { jobSelections, getJobCreateIdFromCookies } = useJobCreate();

  const supportTypeDetails =
    Array.isArray(selectedSupportTypes) && selectedSupportTypes.length > 0
      ? selectedSupportTypes
      : Array.isArray(jobSelections?.supportTypeDetails)
        ? jobSelections.supportTypeDetails
        : [];

  const [selectedActivities, setSelectedActivities] = useState(() => {
    const initial = {};
    const activities = selectedActivitiesValue.length
      ? selectedActivitiesValue
      : jobSelections?.careActivityDetails || [];
    activities.forEach((activity) => (initial[activity] = true));
    return initial;
  });

  const [computedErrors, setComputedErrors] = useState([]);
  const [visibleErrors, setVisibleErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activitiesData, setActivitiesData] = useState([]);

  const [query, setQuery] = useState("");

  const cadcContainerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const jobCreateId = getJobCreateIdFromCookies();
    if (!jobCreateId) {
      navigate("/account/fs-dashboard/my-jobs/new/standard");
    }
  }, [getJobCreateIdFromCookies, navigate]);

  useEffect(() => {
    if (jobSelections?.careActivityDetails) {
      const initialSelected = {};
      jobSelections.careActivityDetails.forEach(
        (activity) => (initialSelected[activity] = true)
      );
      setSelectedActivities(initialSelected);
    }
  }, [jobSelections]);

  useEffect(() => {
    if (isCareActivityDetailsError) {
      const selectedKeys = Object.keys(selectedActivities).filter(k => selectedActivities[k]);
      const fallback = selectedKeys.length === 0
        ? [{ field: "careActivities", message: "Please select at least one care activity." }]
        : [];
      setVisibleErrors(computedErrors.length ? computedErrors : fallback);
      smoothScrollToTop();
    } else {
      setVisibleErrors([]);
    }
  }, [isCareActivityDetailsError, selectedActivities, computedErrors]);

  useEffect(() => {
    if (supportTypeDetails.length > 0) {
      getActivityData()
        .then(setActivitiesData)
        .catch((error) => {
          console.error("Failed to load activities:", error);
          setActivitiesData([]);
        });
    } else {
      setActivitiesData([]);
    }
  }, [supportTypeDetails]);

  const getActivityData = async () => {
    setLoading(true);
    let activities = [];

    if (Array.isArray(supportTypeDetails)) {
      for (const supportTypeLabel of supportTypeDetails) {
        try {
          const fetchedActivities = await fetchActivitiesBySupportTypeLabel(supportTypeLabel);
          activities = activities.concat(fetchedActivities);
        } catch (error) {
          console.error(`Error fetching activities for "${supportTypeLabel}":`, error);
        }
      }
    } else {
      console.error("supportTypeDetails is not a valid array:", supportTypeDetails);
    }

    setLoading(false);
    return activities.map((activity) => ({
      label: activity.name || activity.label,
      description: activity.description,
    }));
  };

  const visibleActivities = useMemo(() => {
    const dedup = new Map();
    for (const a of activitiesData) {
      const label = (a.label || "").trim();
      if (!label) continue;
      const key = label.toLowerCase();
      if (!dedup.has(key)) dedup.set(key, { ...a, label });
    }
    let list = Array.from(dedup.values());
    list.sort((a, b) =>
      a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
    );
    const q = query.trim().toLowerCase();
    if (!q) return list;
    return list.filter((a) => {
      const lbl = a.label.toLowerCase();
      const desc = (a.description || "").toLowerCase();
      return lbl.includes(q) || desc.includes(q);
    });
  }, [activitiesData, query]);

  const toggleActivity = (label) => {
    setSelectedActivities((prevState) => {
      const newState = { ...prevState, [label]: !prevState[label] };
      notifyUpdate(newState);
      return newState;
    });
    clearError && clearError();
  };

  const notifyUpdate = (newSelectedActivities) => {
    const selectedKeys = Object.keys(newSelectedActivities).filter(k => newSelectedActivities[k]);
    const errors = selectedKeys.length === 0
      ? [{ field: "careActivities", message: "Please select at least one care activity." }]
      : [];

    setComputedErrors(errors);
    onUpdate({ data: selectedKeys, errors, isValid: errors.length === 0 });

    if (isCareActivityDetailsError) setVisibleErrors(errors);
    else setVisibleErrors([]);
  };

  const smoothScrollToTop = () => {
    const container = cadcContainerRef.current;
    if (!container) return;
    const scrollDuration = 600;
    const scrollStep = container.scrollTop / (scrollDuration / 15);
    const scrollInterval = setInterval(() => {
      if (container.scrollTop > 0) container.scrollTop -= scrollStep;
      else clearInterval(scrollInterval);
    }, 15);
  };

  return (
    <div className="care-activities-container">
      {/* <h2>Select required support activities.</h2> */}

      {isCareActivityDetailsError && visibleErrors.length > 0 && (
        <div className="wcac-error-message">
          <ul>
            {visibleErrors.map((err, index) => <li key={index}>{err.message}</li>)}
          </ul>
        </div>
      )}

      <div className="activities-search-input-wrapper">
        <FaSearch className="activities-search-icon" />
        <input
          id="activity-search"
          type="text"
          className="language-search-input"
          placeholder="Search activities…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          autoComplete="off"
        />
      </div>

      <div className="care-activities-scrollable" ref={cadcContainerRef}>
        {loading ? (
          <div className="jobs-loading-spinner-container">
              <RotatingLines
                visible={true}
                height="56"
                width="56"
                strokeWidth="1"
                animationDuration="0.75"
                ariaLabel="loading-activities"
              />
          </div>
        ) : visibleActivities.length > 0 ? (

          <ul className="support-activity-list">
            {visibleActivities.map((activity) => {
              const isSelected = !!selectedActivities[activity.label];
              return (
                <li
                  key={activity.label}
                  className={`support-activity-item ${isSelected ? "selected" : ""}`}
                  onClick={() => toggleActivity(activity.label)}
                  role="button"
                  aria-pressed={isSelected}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      toggleActivity(activity.label);
                    }
                  }}
                >
                  <span className="support-activity-icon" aria-hidden="true">✓</span>
                  <span className="support-activity-text">{activity.label}</span>
                </li>
              );
            })}
          </ul>


        ) : activitiesData.length > 0 ? (
          <p>No activities match “{query}”.</p>
        ) : (
          <p>No activities available for the selected support types.</p>
        )}
      </div>
    </div>
  );
};

export default WorkerCareActivitiesComponent;
